require('./loanModifyAssociatedAccountStep1.scss');

const PropTypes = require('prop-types');

// @vendor
const React = require('react');
//@helpers
const { FormattedText, formatText } = require('core/i18n').i18n;
const { getFormattedString } = require('utilities/currencyHelper');
const { getLastNChars } = require('utilities/stringHelper');
const { LoadingSection } = require('commonsComponents/loadingSection');
//@components
const OKInformativeList = require('components/rebrand/OKInformativeList/OKInformativeList');
const OKInformativeListItem = require('components/rebrand/OKInformativeListItem/OKInformativeListItem');
const DropdownAccounts = require('components/dropdownAccounts/dropdownAccounts');
const LoanCollectiveTag = require('../../loanCollectiveTag/loanCollectiveTag');
const { getFilteredAccountIndexes } = require('../../../../loansUtilities/loansHelper');
const { BLOCKED_ACCOUNTS_PREGRANTED_CREDIT } = require('constants/operationCodesAccounts');

class LoanModifyAssociatedAccountStep1 extends React.PureComponent {

    componentDidMount(){
        const { immAccounts, getBlockedAccounts } = this.props;
            const accounts = getFilteredAccountIndexes(immAccounts).map(id => immAccounts.getIn(['byId', id]));
            getBlockedAccounts(accounts, BLOCKED_ACCOUNTS_PREGRANTED_CREDIT);
    }

    buildBadge() {
        const { immLoan } = this.props;

        return (
            <LoanCollectiveTag
                extraClass="loan-modify-associated-account-step-one__collective-tag"
                immLoan={immLoan}
            />
        )
    }

    render() {
        const { immAccount, immLoanModifyAssociatedAccount, immAccounts, accountsIndexes, onAccountChange } = this.props;
        const newAccountId = immLoanModifyAssociatedAccount.get('newAccountId');
        const newAccountRequiredAlertVisible = immLoanModifyAssociatedAccount.get('newAccountIsDirty') && (newAccountId === '' || newAccountId === undefined);
        const accountType = immAccount.get('catalogData').get('product');
        const formattedIban = getLastNChars(immAccount.get('iban'));
        const accountBalance = getFormattedString(immAccount.get('balance'));
        const errorMessage = formatText('loanModifyAssociatedAccount-firstStepAccountRequiredMessage');
        const badge = this.buildBadge();

        return (
            <div className="loan-modify-associated-account-step-one">
                <header className="loan-modify-associated-account-step-one__header">
                    <FormattedText value="loanModifyAssociatedAccount-firstStepTitle" className="loan-modify-associated-account-step-one__title" />
                    {badge}
                </header>
                <article>
                    <FormattedText value="loanModifyAssociatedAccount-firstStepSubtitle" className="loan-modify-associated-account-step-one__subtitle" />
                    <OKInformativeList columns={3}>
                        <OKInformativeListItem
                            title={formatText('loanModifyAssociatedAccount-firstStepOwner')}
                            bodyText={immAccount.get('accountHolder')}
                            bodyWordBreak={false}
                        />
                        <OKInformativeListItem
                            title={immAccount.get('alias')}
                            bodyText={`${accountType} ${formattedIban}`}
                        />
                        <OKInformativeListItem
                            title={formatText('loanModifyAssociatedAccount-firstStepBalance')}
                            bodyText={accountBalance}
                        />
                    </OKInformativeList>
                    <div className="loan-modify-associated-account-step-one__account-section">
                        {
                        !immAccounts.get('blockedAccountsLoading') ? (
                        <DropdownAccounts
                            label={'loanModifyAssociatedAccount-firstStepAccount'}
                            blockedAccountsAll={immAccounts.get('blockedAccountsAll')}
                            blockedAccountsIds={immAccounts.get('blockedAccountsIds')}
                            immAccounts={immAccounts.get('byId')}
                            currentAccountId={newAccountId}
                            accountsIndexes={accountsIndexes}
                            onAccountChange={onAccountChange}
                            error={newAccountRequiredAlertVisible}
                            errorMsg={errorMessage}
                            showInactiveAccountsAsBlocked
                            showAvailableBalance
                        />
                        ) : <LoadingSection />
                            }
                    </div>
                </article>
            </div>
        );
    }
}

LoanModifyAssociatedAccountStep1.propTypes = {
    getBlockedAccounts: PropTypes.func.isRequired,
    immAccount: PropTypes.object.isRequired,
    immLoan: PropTypes.object.isRequired,
    immLoanModifyAssociatedAccount: PropTypes.object.isRequired,
    immAccounts: PropTypes.object.isRequired,
    accountsIndexes: PropTypes.array.isRequired,
    onAccountChange: PropTypes.func.isRequired
};

module.exports = LoanModifyAssociatedAccountStep1;
